<template>

<com-item name="game.peers.heatmap" :size="size" :is-empty="!active" :loading="loading" title="Play Activity" class="heatmap type-plays">

	<template v-slot:about>

		<p>Community play activity for this game over the last 10 years.</p>

	</template>

	<template v-slot:stats>

		<div class="heatmap-graph" v-show="active">

			<div class="heatmap-wrapper">

				<div class="heatmap-weeks" v-show="active">

					<div class="heatmap-week is-labels">
						<div v-for="year in years" v-bind:key="year" class="heatmap-day"><span>{{ year }}</span></div>
					</div>

					<div class="heatmap-week" v-for="(week, index) in weeks" v-bind:key="index">

						<div class="heatmap-day" v-tooltip="tooltip(day)" v-for="(day, dindex) in days(week)" v-bind:class="{'is-inactive': day.inactive, 'has-plays': day.plays, [playDensity(day)]: !day.inactive}" v-bind:key="dindex">

						</div>

					</div>

				</div>

			</div>

		</div>

	</template>

</com-item>

</template>

<script>

import comItem from './../common/Item'

export default {

	props: ['fetching', 'you', 'your', 'size'],

	components: {
		'com-item': comItem
	},

	data: function() {

		return {
			weeks: []
		}

	},

	computed: {

		years: function() {

			var years = []
			var max = parseInt(this.$moment.utc().format('YYYY'))
			var min = max - 9

			for (var i = max; i >= min; i--) {

				years.push(i)

			}

			return years

		},

		loading: function() { return this.fetching === 'all' },

		storeData: function() { return this.$store.getters['page/insights/game/peers'] },

		heatmap: function() { return (this.storeData && this.storeData.communityHeatmap) ? this.storeData.communityHeatmap : null },

		active: function() { return this.heatmap && this.heatmap.total && !this.loading }

	},

	created: function() {

		for (var i = 1; i <= 53; i++) {

			var days = []

			for (var j = 1; j <= 10; j++) {

				days.push({ plays: 0, date: '', inactive: true })

			}

			this.weeks.push({ days: days })

		}

		this.visualise()

	},

	watch: {

		storeData: function() { this.visualise() }

	},

	methods: {

		tooltip: function(day) {

			if (!day.inactive && day.plays) {

				return day.plays.toString() + this.$util.plural(' play', day.plays) + '<small>' + day.date + '</small>'

			}

			return false

		},

		days: function(week) {

			return week.days.slice(0, 10)

		},

		playDensity: function(day) {

			var density = Math.ceil(day.plays / 5)
			if (density > 5) density = 5

			return 'density-' + density

		},

		visualise: function() {

			if (!this.heatmap || !this.heatmap.plays) return

			var max = parseInt(this.$moment.utc().format('YYYY'))
			var min = max - 9
			var plays = this.heatmap.plays

			for (var i = 1; i <= 53; i++) {

				for (var j = max; j >= min; j--) {

					var stamp = j + '/' + i
					var entry = plays[stamp] || {}
					var col = max - j

					var currentDate = this.$moment.utc().year(j).startOf('year').day(1).add((i - 1) * 7, 'days')

					if (i === 53 || currentDate.isAfter(this.$moment.utc())) {

						this.weeks[i - 1].days[col].plays = false
						this.weeks[i - 1].days[col].date = false
						this.weeks[i - 1].days[col].inactive = true

					} else {

						this.weeks[i - 1].days[col].plays = entry.count || 0
						this.weeks[i - 1].days[col].date = currentDate.format(this.$util.date.format('Do', 'MMM', ', YYYY'))
						this.weeks[i - 1].days[col].inactive = false

					}

				}

			}

		}

	}

}

</script>

<style scoped>

.heatmap >>> .insights-item-content {
	min-height: auto;
	overflow-y: auto;
}

.heatmap-graph {
	width: 100%;
	padding: 15px;
	min-width: 900px;
}

.heatmap-wrapper {
	width: 100%;
}

.heatmap-weeks {
	width: 100%;
	display: grid;
	grid-template-columns: repeat(55, minmax(0, 1fr));
}

.heatmap-week {
	display: flex;
	flex-direction: column;
}

.heatmap-week.is-labels {
	grid-column: span 2;
}

.heatmap-day {
	border-radius: 4px;
	border: 1px solid #fff;
	transition: background-color 400ms ease-out;
	width: 100%;
	padding-top: calc(100% - 2px);
}

.heatmap-week.is-labels .heatmap-day {
	padding-top: calc(50% - 2px);
}

.heatmap-day.has-plays {
	cursor: default;
}

.heatmap-week.is-labels .heatmap-day span {
	position: absolute;
	color: #333;
	left: 0px;
	width: 100%;
	top: 50%;
	text-align: left;
	font-size: 10px;
	transform: translateY(-50%);
}

.heatmap-day.is-inactive {
	background-color: #ffffff!important;
}

.heatmap.type-plays .heatmap-day.density-0 { background-color: rgba(17, 105, 135, 0.03); }
.heatmap.type-plays .heatmap-day.density-1 { background-color: rgba(17, 105, 135, 0.2); }
.heatmap.type-plays .heatmap-day.density-2 { background-color: rgba(17, 105, 135, 0.4); }
.heatmap.type-plays .heatmap-day.density-3 { background-color: rgba(17, 105, 135, 0.6); }
.heatmap.type-plays .heatmap-day.density-4 { background-color: rgba(17, 105, 135, 0.8); }
.heatmap.type-plays .heatmap-day.density-5 { background-color: rgba(17, 105, 135, 1); }

</style>
